export interface MainButton {
  text: string;
  isVisible: boolean;
  isActive: boolean;
  show: () => void;
  hide: () => void;
  enable: () => void;
  disable: () => void;
  setText: (text: string) => void;
  onClick: (cb: () => void) => void;
  offClick: (cb: () => void) => void;
  setParams: (p: {
    text?: string;
    color?: string;
    text_color?: string;
    is_active?: boolean;
    is_visible?: boolean;
  }) => void;
  showProgress: (leaveActive?: boolean) => void;
  hideProgress: () => void;
}

export interface HapticFeedback {
  impactOccurred: (style: "light" | "medium" | "heavy" | "rigid" | "soft") => void;
  notificationOccurred: (type: "error" | "success" | "warning") => void;
  selectionChanged: () => void;
}

export interface TelegramWebApp {
  initData: string;
  initDataUnsafe: {
    user?: { id: number; first_name: string; username?: string };
    start_param?: string;
  };
  ready: () => void;
  expand: () => void;
  close: () => void;
  MainButton: MainButton;
  HapticFeedback?: HapticFeedback;
  setHeaderColor?: (hex: string) => void;
  setBackgroundColor?: (hex: string) => void;
  /** Bot API 7.7+ — убирает свайп «вниз чтобы закрыть». */
  disableVerticalSwipes?: () => void;
  /** Bot API 8.0+ — полноэкранный режим. Не поддерживается старыми клиентами. */
  requestFullscreen?: () => void;
  exitFullscreen?: () => void;
  isFullscreen?: boolean;
  /** Bot API 8.0+ — блокировка ориентации на мобильных устройствах. */
  lockOrientation?: (orientation: "portrait" | "landscape") => void;
  unlockOrientation?: () => void;
}

/**
 * Deep-link param из Telegram (?startapp=letter_04 или match_02).
 * Фоллбек — URL ?startapp=... чтобы можно было тестить в браузере.
 */
export function getStartParam(): string | null {
  const tg = getTelegram();
  const fromTg = tg?.initDataUnsafe.start_param ?? null;
  if (fromTg) return fromTg;
  if (typeof window === "undefined") return null;
  const url = new URL(window.location.href);
  return url.searchParams.get("startapp") ?? url.searchParams.get("tgWebAppStartParam");
}

/**
 * Парсит startapp: "letter_04" → ["/letter", "04"], "match_02" → ["/match", "02"].
 * Возвращает null если не распознан.
 */
export function resolveDeepLink(param: string | null): string | null {
  if (!param) return null;
  const m = /^(letter|match|profile)_([A-Za-z0-9-]+)$/.exec(param);
  if (!m) return null;
  const [, kind, id] = m;
  return `/${String(kind)}/${String(id)}`;
}

export function getTelegram(): TelegramWebApp | null {
  if (typeof window === "undefined") return null;
  const w = window as unknown as { Telegram?: { WebApp?: TelegramWebApp } };
  const app = w.Telegram?.WebApp;
  if (!app) return null;
  if (!app.initData && !app.initDataUnsafe.user) return null;
  return app;
}

export function haptic(
  kind: "light" | "medium" | "heavy" | "rigid" | "soft" | "success" | "warning" | "error"
): void {
  const tg = getTelegram();
  if (!tg?.HapticFeedback) return;
  if (kind === "success" || kind === "warning" || kind === "error") {
    tg.HapticFeedback.notificationOccurred(kind);
  } else {
    tg.HapticFeedback.impactOccurred(kind);
  }
}
